import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const RhombusRectangular = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.583 19.333H18.818C20.011 19.333 20.886 18.212 20.597 17.055L17.847 6.055C17.643 5.239 16.91 4.666 16.068 4.666H5.583C4.571 4.667 3.75 5.487 3.75 6.5V17.5C3.75 18.513 4.571 19.333 5.583 19.333Z"
      />
    </svg>
  );
};
